<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vi"></a><em>To Ellen—love of my life, best friend, and luminous critic</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230240582_06_dedication.vue?678ed0bf